function _typeof(o) {
    '@babel/helpers - typeof';
    return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (o) {
        return typeof o;
    } : function (o) {
        return o && 'function' == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? 'symbol' : typeof o;
    }, _typeof(o);
}
function _classCallCheck(a, n) {
    if (!(a instanceof n))
        throw new TypeError('Cannot call a class as a function');
}
function _defineProperties(e, r) {
    for (var t = 0; t < r.length; t++) {
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, 'value' in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, 'prototype', { writable: !1 }), e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, 'string');
    return 'symbol' == _typeof(i) ? i : i + '';
}
function _toPrimitive(t, r) {
    if ('object' != _typeof(t) || !t)
        return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != _typeof(i))
            return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return ('string' === r ? String : Number)(t);
}
var Subtitle = function () {
    function Subtitle(container, video, options, events) {
        _classCallCheck(this, Subtitle);
        this.container = container;
        this.video = video;
        this.options = options;
        this.events = events;
        this.init();
    }
    return _createClass(Subtitle, [
        {
            key: 'init',
            value: function init() {
                var _this = this;
                this.container.style.fontSize = this.options.fontSize;
                this.container.style.bottom = this.options.bottom;
                this.container.style.color = this.options.color;
                if (this.video.textTracks && this.video.textTracks[0]) {
                    var track = this.video.textTracks[0];
                    track.oncuechange = function () {
                        var cue = track.activeCues[track.activeCues.length - 1];
                        _this.container.innerHTML = '';
                        if (cue) {
                            var template = document.createElement('div');
                            template.appendChild(cue.getCueAsHTML());
                            var trackHtml = template.innerHTML.split(/\r?\n/).map(function (item) {
                                return '<p>'.concat(item, '</p>');
                            }).join('');
                            _this.container.innerHTML = trackHtml;
                        }
                        _this.events.trigger('subtitle_change');
                    };
                }
            }
        },
        {
            key: 'show',
            value: function show() {
                this.container.classList.remove('dplayer-subtitle-hide');
                this.events.trigger('subtitle_show');
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.container.classList.add('dplayer-subtitle-hide');
                this.events.trigger('subtitle_hide');
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.container.classList.contains('dplayer-subtitle-hide')) {
                    this.show();
                } else {
                    this.hide();
                }
            }
        }
    ]);
}();
export default Subtitle;